import { Pipe, PipeTransform } from "@angular/core";

/*
 * Converts spaces from wysiwyg into plain spaces
 * Usage:
 *   value | convertSpaces
 * Example:
 *   {{ '&nbsp;&nbsp; a&nbsp;' | convertSpaces }}
 *   formats to: '   a '
 */
@Pipe({ name: "convertSpaces" })
export class ConvertSpacesPipe implements PipeTransform {
  transform(html: string): string {
    return html.replace(/\u200B/gi, "").replace(/&[^;]+;/gi, " ");
  }
}
